<template>
    <div>
        <v-simple-table>
            <slot/>
        </v-simple-table>
    </div>
</template>

<script>
export default {
    name: 'vtable'
}
</script>

<style lang="scss">
    ::v-deep {
        @media screen and (max-width: 680px) {
            .v-data-table__wrapper {
                overflow-y: visible;
                overflow-x: visible;
            }
        }
        
    }
</style>